export const CURRENCY = [
  { label: "AMD", value: "AMD" },
  { label: "USD", value: "USD" },
  { label: "RUB", value: "RUB" },
  { label: "EUR", value: "EUR" },
  { label: "CHF", value: "CHF" },
  { label: "GBP", value: "GBP" },
];
